import ChoroplethViz from '../vizs/ChoroplethViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display thematic data, in which areas are shaded or patterned in proportion to a statistical variable that represents an aggregate summary of a geographic characteristic within each area, such as population density or per-capita income.
 * 
 * Choropleth maps provide an easy way to visualize how a measurement varies across a geographic area or show the level of variability within a region.
 *
 *  ### Example Usage
 * ```javascript
 *   import {ChoroplethSeq} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new ChoroplethSeq($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 columns.
 * 
 * Each row represents a region in the map. 
 * 
 * The first column represents the id of the region (goejson feature). See [maps](#/developer/PropDetails#features) for more info on how to get the right ids in each case.
 * 
 * The second column represents value that will be used to color the reagion.
 * 
 * | id           |  value|  
 * | --------     | ------ |  
 * |   ESP        |    43.4|   
 * |   FRA        |    24.6|    
 * |   USA        |   15.7|     
 * |   GBR        |    53.5|   
 * 
 * {.data-table}

 * */
export default class ChoroplethSeqComponent extends BaseComponent {
  static vizClass = ChoroplethViz
  static componentLabel = "Choropleth Map"
  static dataFormat = [
    {index: 0, axis:'', label: 'id', types:[String], role: 'feature-id', roleLabel: 'Area'},
    {index: 1, axis:'', label: 'value', types:[Number, null], role: 'value', roleLabel: 'Value'},
  ]
  static defaultConfig = {
    title: this.componentLabel,
    valueFormat: {
      type: [String,Array,Function,null],
      default: null
    },
    unit: {
      type: [String,Boolean,null],
      default: false
    },
    ItemsHelper: {
      colorScale: {
        value: 'sequential2',
        options: ['sequential2','sequential3']
      },
    },
    TooltipBehavior:{
      getHtml: function(d){
        return `
          <span class="important">${this.valueWithUnit(d.value)}</span>
          <br/>
          ${d.label}
        `
      },
    }
  }
}